// extracted by mini-css-extract-plugin
module.exports = {"tokenIcons":"tokenIcons_tokenIcons__MEYj_"};